import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Plus, Users, Building2 } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import { money, moneyK, fecha, Title, Badge, Empty } from './ui';

export default function AgenciaClientes() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ search: '', estado: '', tipo: '', agencia: '' });
  const [listas, setListas] = useState({ agencias: [] });
  const [nuevo, setNuevo] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get('/agency/clientes', { params: f }).then(r => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [f]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  useEffect(() => { api.get('/agency/listas').then(r => setListas(r.data)).catch(() => {}); }, []);

  const crear = async (e) => {
    e.preventDefault();
    try { const r = await api.post('/agency/clientes', nuevo); toast.success('Cliente creado'); setNuevo(null); navigate('/agencia/clientes/' + r.data.id); }
    catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  const th = { textAlign: 'left', fontSize: 11, color: 'var(--text-muted)', fontWeight: 700, padding: '8px' };
  const td = { padding: '10px 8px', borderTop: '1px solid var(--border)', fontSize: 13 };
  const totales = rows.reduce((a, r) => ({ fact: a.fact + Number(r.total_facturado || 0), pend: a.pend + Number(r.pendiente || 0) }), { fact: 0, pend: 0 });

  return (
    <div>
      <Title right={<button className="btn btn-primary" onClick={() => setNuevo({ nombre: '', tipo: 'cliente', estado: 'activo' })}><Plus size={16} /> Nuevo cliente</button>}>
        Clientes de la agencia
      </Title>

      <div className="card" style={{ marginBottom: 16, padding: '12px 14px', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: '1 1 220px', maxWidth: 320 }}>
          <Search size={15} style={{ position: 'absolute', left: 11, top: 11, color: 'var(--text-muted)' }} />
          <input value={f.search} onChange={e => setF({ ...f, search: e.target.value })} placeholder="Buscar por nombre, CUIT o nombre anterior" style={{ paddingLeft: 32, fontSize: 13 }} />
        </div>
        <select value={f.estado} onChange={e => setF({ ...f, estado: e.target.value })} style={{ width: 'auto', fontSize: 13 }}>
          <option value="">Todos los estados</option><option value="activo">Activos</option><option value="inactivo">Inactivos</option><option value="prospecto">Prospectos</option>
        </select>
        <select value={f.tipo} onChange={e => setF({ ...f, tipo: e.target.value })} style={{ width: 'auto', fontSize: 13 }}>
          <option value="">Clientes y agencias</option><option value="cliente">Solo clientes</option><option value="agencia">Solo agencias</option>
        </select>
        <select value={f.agencia} onChange={e => setF({ ...f, agencia: e.target.value })} style={{ width: 'auto', fontSize: 13 }}>
          <option value="">Cualquier origen</option>
          {listas.agencias.map(a => <option key={a.id} value={a.id}>Traídos por {a.nombre}</option>)}
        </select>
        <div style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>
          {rows.length} clientes · facturado {moneyK(totales.fact)}{totales.pend > 0 && ` · por cobrar ${moneyK(totales.pend)}`}
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-container">
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>
              <th style={th}>Cliente</th><th style={th}>Origen</th><th style={th}>Estado</th>
              <th style={{ ...th, textAlign: 'right' }}>Facturado</th><th style={{ ...th, textAlign: 'right' }}>Por cobrar</th>
              <th style={th}>Último cobro</th><th style={th}>Contratos</th><th style={th}>Portal</th>
            </tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={8} style={{ ...td, color: 'var(--text-muted)' }}>Cargando...</td></tr>
                : rows.length === 0 ? <tr><td colSpan={8} style={td}><Empty>No hay clientes con ese filtro</Empty></td></tr>
                : rows.map(c => (
                  <tr key={c.id} onClick={() => navigate('/agencia/clientes/' + c.id)} style={{ cursor: 'pointer' }}>
                    <td style={td}>
                      <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                        {c.tipo === 'agencia' && <Building2 size={14} color="var(--accent)" />}{c.nombre}
                      </div>
                      {c.cuit && <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>CUIT {c.cuit}</div>}
                    </td>
                    <td style={{ ...td, color: 'var(--text-secondary)' }}>{c.agencia || (c.tipo === 'agencia' ? 'Agencia' : 'Directo')}</td>
                    <td style={td}><Badge label={c.estado} color={c.estado === 'activo' ? '#22c55e' : 'var(--text-muted)'} /></td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{money(c.total_facturado)}</td>
                    <td style={{ ...td, textAlign: 'right', color: Number(c.pendiente) ? '#f59e0b' : 'var(--text-muted)' }}>{Number(c.pendiente) ? money(c.pendiente) : '—'}</td>
                    <td style={{ ...td, whiteSpace: 'nowrap', color: 'var(--text-muted)' }}>{fecha(c.ultimo_cobro)}</td>
                    <td style={td}>{c.contratos || '—'}</td>
                    <td style={td}>{c.usuarios ? <Users size={14} color="#22c55e" /> : <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {nuevo && (
        <div className="modal-overlay" onClick={() => setNuevo(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 460 }}>
            <h2>Nuevo cliente</h2>
            <form onSubmit={crear}>
              <div className="form-group"><label>Nombre *</label><input value={nuevo.nombre} onChange={e => setNuevo({ ...nuevo, nombre: e.target.value })} required autoFocus /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group"><label>Tipo</label>
                  <select value={nuevo.tipo} onChange={e => setNuevo({ ...nuevo, tipo: e.target.value })}><option value="cliente">Cliente</option><option value="agencia">Agencia</option></select>
                </div>
                <div className="form-group"><label>Traído por</label>
                  <select value={nuevo.agencia_id || ''} onChange={e => setNuevo({ ...nuevo, agencia_id: e.target.value })}>
                    <option value="">Directo</option>
                    {listas.agencias.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group"><label>CUIT</label><input value={nuevo.cuit || ''} onChange={e => setNuevo({ ...nuevo, cuit: e.target.value })} /></div>
              <div className="form-group"><label>Email</label><input type="email" value={nuevo.email_facturacion || ''} onChange={e => setNuevo({ ...nuevo, email_facturacion: e.target.value })} /></div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 16 }}>
                <button type="button" className="btn btn-secondary" onClick={() => setNuevo(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Crear</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
